module.exports = __webpack_public_path__ + "media/mimi.8b46d560.mp3";